import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { ReactSelect } from 'components';
import { kebabCase } from 'lodash';

const PeerOrganization = ({ suggestions, onSuggest, organizations, onChange }) => {
  const [options, setOptions] = useState();
  const [once, setOnce] = useState(true);
  const [selected, setSelected] = useState();
  const [noOptionsMessage, setNoOptionsMessage] = useState(null);

  const handleNameChange = (value) => {
    if(value.length > 2) {
      if(once) {
        const orgs = organizations.map(({ id, orgName }) => ({ value: id, label: orgName }));
        setOnce(false);
        setOptions(orgs);
      }
      setNoOptionsMessage("No Organizations Found");
    } else {
      setOptions([]);
      setOnce(true);
      setNoOptionsMessage(null);
    }
  }

  const handleChange = ({value}) => {
    onChange(value);
    setTimeout(() => {
      setSelected('');
    }, 500);
  }

  return (
    <div className="d-print-none">
      <Row>
        <Col>
          <EmptyImage />
        </Col>
      </Row>
      <Row>
        <OrganizationName>Add Another Organization</OrganizationName>
      </Row>
      <Row>
        <Col></Col>
      </Row>
      <Row>
        <Col>
          <Suggestions>
            <li>
              Suggestion <span>(click to add)</span>
            </li>
            {suggestions &&
              suggestions.map((item) => (
                <li key={kebabCase(item.orgName)}>
                  <a href="javascript:void(0)" onClick={() => onSuggest(item)} dangerouslySetInnerHTML={{ __html: item.orgName }} />
                </li>
              ))}
          </Suggestions>
        </Col>
      </Row>
      <Row>
        <Col>Search</Col>
      </Row>
      <Row>
        <Col>
          {' '}
          <ReactSelect
            options={options}
            value={selected}
            placeholder="Organization"
            onInputChange={handleNameChange}
            onChange={handleChange}
            noOptionsMessage={() => noOptionsMessage}
          />
        </Col>
      </Row>
    </div>
  );
};

const Suggestions = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;

  > li {
    margin-bottom: 0.3rem;

    > a {
      color: ${({ theme }) => theme.palette.primary[0]};
    }

    :first-child {
      font-weight: 600;
      > span {
        font-weight: 300;
        color: ${({ theme }) => theme.palette.grayscale[5]};
      }
    }
  }
`;

const EmptyImage = styled.div`
  height: 100px;
  width: 100px;
  border: 1px solid ${({ theme }) => theme.palette.grayscale[5]};
  margin: 1rem auto;
`;

const OrganizationName = styled(Col)`
  color: ${({ theme }) => theme.palette.grayscale[5]};
  text-align: center;
  margin-bottom: 3rem;
`;

export default PeerOrganization;
